import { Component, OnInit, inject } from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {DataService} from "../../../services/data.service";
import {AccessService} from "../../../services/access.service";
import {BackupService} from "../../../services/backup.service";
import {ViewMode} from "../../interfaces";
import Swal from "sweetalert2";
import {ToastrService} from "ngx-toastr";
import {NgForOf, NgIf} from "@angular/common";

@Component({
    selector: 'app-contact-detail',
    templateUrl: './contact-detail.component.html',
    imports: [
        NgIf,
        ReactiveFormsModule,
        RouterLink,
        NgForOf
    ],
    styleUrl: './contact-detail.component.scss'
})
export class ContactDetailComponent implements OnInit {

    accessService = inject(AccessService);
    private router = inject(Router);
    private fb = inject(UntypedFormBuilder);
    private dataService = inject(DataService);
    private route = inject(ActivatedRoute);
    private toastrService = inject(ToastrService);

    readonly ViewMode = ViewMode;

    form!: UntypedFormGroup;
    id_contact!: string;
    viewMode!: ViewMode;
    contact: any;
    customers: any[];

    ngOnInit(): void {
        this.id_contact = this.route.snapshot.paramMap.get('id');
        this.viewMode = this.id_contact == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            id_customer: [''],
            name: [null, Validators.required],
            zip: [null],
            city: [null],
            street: [null],
            phone: [null],
            mail: [null],
            customer: [null],
        });

        if (this.id_contact !== '0') {
            this.getContact();
        }

        this.dataService.request('Customer/listForTask').subscribe(response => {
            this.customers = response.customers;
        });
    }

    getContact(): void {
        this.dataService.request('Contact/get', {
            id_contact: this.id_contact
        }).subscribe(response => {
            this.contact = response.contact;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.contact.id,
            id_customer: this.contact.id_customer ?? '',
            name: this.contact.name,
            zip: this.contact.zip,
            city: this.contact.city,
            street: this.contact.street,
            phone: this.contact.phone,
            mail: this.contact.mail,
            customer: this.contact.customer,
        });
    }

    save(): void {
        this.dataService.request('Contact/save', {
            contact: this.form.getRawValue(),
        }).subscribe(() => {
            this.router.navigate(['/contact']);
            this.toastrService.success('Der Kontakt wurde angelegt');
        });
    }

    update(): void {
        this.dataService.request('Contact/update', {
            contact: this.form.getRawValue(),
        }).subscribe(() => {
            this.setMode(ViewMode.VIEW);
            this.getContact();
            this.toastrService.success('Der Kontakt wurde aktualisiert');
        });
    }

    cancel(): void {
        this.router.navigate(['/contact']);
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
        this.getContact();
    }

    delete(): void {
        Swal.fire({
            title: 'Sicher?',
            text: 'Der Kontakt wird gelöscht.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nein'
        }).then(result => {
            if (result.value) {
                this.dataService.request('Contact/delete', {
                    id_contact: this.id_contact
                }).subscribe(() => {
                    this.cancel();
                    this.toastrService.success('Der Kontakt wurde gelöscht');
                });
            }
        });
    }

}
